import Mustache from "mustache"
import { addEventListenerWithKey } from "shared/lib/utils.js"
import { onBFCacheLoad } from "shared/scripts/back_forward_cache_utils"
import { loadUserRecentSearches } from "app/components/universal_search/search_history"
import { recommendationTemplate, searchHistoryTemplate } from "./templates"

export const TOTAL_MAX_RECENT_SEARCHES = 4

// This component is responsible to load and display recent searches
export const RecentSearches = () => {
  const searchHistory = loadUserRecentSearches().slice(0, TOTAL_MAX_RECENT_SEARCHES)

  const populateRecentSearches = (searchHistory: string[]) => {
    document.querySelectorAll(".recent-searches").forEach(historyWrapper => {
      if (searchHistory.length > 0) {
        historyWrapper.classList.remove("hide")

        const historyList = historyWrapper.querySelector("ul.universal-search-helper-list")
        if (!historyList) return

        historyList.innerHTML = ""
        searchHistory.forEach(({ type, term, details }) => {
          const variables = {
            term,
            query_term: term.toLowerCase(),
            ...details,
          }

          const rendered = Mustache.render(
            type === "service" ? recommendationTemplate : searchHistoryTemplate,
            variables
          )
          historyList.insertAdjacentHTML("beforeend", rendered)
        })
      } else {
        historyWrapper.classList.add("hide")
      }
    })
  }

  if (document.querySelector("#explore-search")) {
    // Universal header doesn't need to update history since user will be redirected.
    addEventListenerWithKey(window, "search-history:updated", "recent_searches_history_updated", () => {
      populateRecentSearches(loadUserRecentSearches().slice(0, TOTAL_MAX_RECENT_SEARCHES))
    })
  }

  populateRecentSearches(searchHistory)

  onBFCacheLoad("recent_searches", () => {
    RecentSearches()
  })
}
